const VERSION_KEY = "app_version";
const POLL_INTERVAL = 60 * 1000;
const SNOOZE_DURATION = 30 * 60 * 1000;

export default {
  data() {
    return {
      updateExists: false,
      updateSuccessSnackbar: false,
      currentVersion: process.env.VUE_APP_VERSION || "—",
      pollIntervalId: null,
      snoozeTimeoutId: null,
      visibilityHandler: null,
    };
  },
  created() {
    this.checkVersionUpdate();
  },
  mounted() {
    if (process.env.NODE_ENV !== "production") return;

    this.pollForUpdate();
    this.pollIntervalId = setInterval(() => this.pollForUpdate(), POLL_INTERVAL);

    this.visibilityHandler = () => {
      if (document.visibilityState === "visible") {
        this.pollForUpdate();
      }
    };
    document.addEventListener("visibilitychange", this.visibilityHandler);
  },
  beforeDestroy() {
    if (this.pollIntervalId) clearInterval(this.pollIntervalId);
    if (this.snoozeTimeoutId) clearTimeout(this.snoozeTimeoutId);
    if (this.visibilityHandler) {
      document.removeEventListener("visibilitychange", this.visibilityHandler);
    }
  },
  methods: {
    checkVersionUpdate() {
      try {
        const stored = localStorage.getItem(VERSION_KEY);
        if (stored && stored !== this.currentVersion) {
          this.updateSuccessSnackbar = true;
        }
        localStorage.setItem(VERSION_KEY, this.currentVersion);
      } catch (e) {
        // localStorage unavailable (e.g. private browsing)
      }
    },
    async pollForUpdate() {
      if (this.updateExists) return;

      try {
        const res = await fetch("/version.json?_=" + Date.now(), {
          cache: "no-store",
          headers: { "Cache-Control": "no-cache" },
        });
        if (!res.ok) return;

        const data = await res.json();
        if (data.version && data.version !== this.currentVersion) {
          this.updateExists = true;
        }
      } catch (e) {
        // Fail silently on network errors
      }
    },
    async refreshApp() {
      try {
        if ("serviceWorker" in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map((registration) => registration.unregister()));
        }
        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
        }
      } catch (e) {
        // Proceed with reload even if cache cleanup fails
      }
      window.location.reload();
    },
    snoozeUpdate() {
      this.updateExists = false;
      if (this.snoozeTimeoutId) clearTimeout(this.snoozeTimeoutId);
      this.snoozeTimeoutId = setTimeout(() => {
        this.pollForUpdate();
      }, SNOOZE_DURATION);
    },
  },
};
